/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerFormAssetCode: "trailer-form-asset-code",
  trailerFormLicenseNumber: "trailer-form-license-number",
  trailerFormVin: "trailer-form-vin",
  trailerFormSerialNumber: "trailer-form-serial-number",
  trailerFormTrailerType: "trailer-form-trailer-type",
  trailerFormOwnedTrailerTypeOption: "trailer-form-owned-trailer-type-option",
  trailerFormOtherTrailerTypeOption: "trailer-form-other-trailer-type-option",
  trailerFormHasMeteredPump: "trailer-form-has-metered-pump",
  trailerFormMaxWeightWithUnit: "trailer-form-max-weight-with-unit",
  trailerFormNumberOfAxles: "trailer-form-number-of-axles",
  trailerFormMinTemperatureWithUnit: "trailer-form-min-temperature-with-unit",
  trailerFormIdentifier: "trailer-form-identifier",
  trailerFormImport: "trailer-form-import",
  trailerFormOpenDocument: "trailer-form-open-document",
  trailerFormRemoveDocument: "trailer-form-remove-document",
  trailerFormSave: "trailer-form-save",
} as const;
